export default __webpack_public_path__ + "static/media/specieslistprologo.7bc1467d.png";